import { http } from '@/api/Connect';
import { BASE_OPERATOR } from '@/api/CopyStake/BaseUrls';
import { buildUrl } from '@/helpers/buildUrl';
import { AxiosResponse } from 'axios';

import {
  DateRangeParams,
  ICopyStakeChartDataParam,
  ICopyStakeDashboardStatsDataResponse,
  ICopyStakeDashboardViewersDataResponse,
  TCopyStakeDashboardChartDataResponse
} from '@/api/schema';

const API_DASHBOARD_STATS = (): string =>
  buildUrl(`/api/v1/app/stats/{operatorId}/dashboard`);

export async function getCopyStakeChartData(
  params: ICopyStakeChartDataParam
): Promise<TCopyStakeDashboardChartDataResponse> {
  return http
    .get(`${API_DASHBOARD_STATS()}/chart`, {
      params
    })
    .then(
      ({ data }: AxiosResponse): TCopyStakeDashboardChartDataResponse => data
    );
}

export async function getCopyStakeDashboardStats(
  params: DateRangeParams
): Promise<ICopyStakeDashboardStatsDataResponse> {
  return http
    .get(API_DASHBOARD_STATS(), {
      params
    })
    .then(
      ({ data }: AxiosResponse): ICopyStakeDashboardStatsDataResponse => data
    );
}

export async function getCopyStakeDashboardViewers(
  params: DateRangeParams
): Promise<ICopyStakeDashboardViewersDataResponse> {
  return http
    .get(`${API_DASHBOARD_STATS()}/viewers`, {
      params
    })
    .then(
      ({ data }: AxiosResponse): ICopyStakeDashboardViewersDataResponse => data
    );
}

export async function getCopyStakeDashboardLoyaltyStats(
  params: DateRangeParams
): Promise<ICopyStakeDashboardStatsDataResponse> {
  return http
    .get(`${BASE_OPERATOR()}/dashboard/stats/loyalty`, {
      params
    })
    .then(
      ({ data }: AxiosResponse): ICopyStakeDashboardStatsDataResponse => data
    );
}
